import getBlock from './block';

const getBlockSettings = (rootState, blockId) => {
  const block = getBlock(rootState, blockId);

  if (!block || !block.availableSettings) {
    return null;
  }

  return block.availableSettings;
};

export default getBlockSettings;
